/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.swipers = {};

// Swatch clicks on product cards. A single delegated listener serves every card, including the ones added later by
// "load more", AJAX filters/sort, search, recommendations or recently viewed, so nothing has to be re-bound.
document.addEventListener('change', function(event) {
  var input = event.target;
  if (!input.classList || !input.classList.contains('ce-variantes-piedras__input')) return;

  var container = input.closest('div[id^="fieldset-"]');
  var card = input.closest('.ProductItem');
  if (!container || !card) return;

  var productId = card.getAttribute('data-product-id');
  var infoIndex = container.getAttribute('data-index');

  var labels = container.querySelectorAll('.ce-color-variantes__item');

  labels.forEach(function(label) {
      label.classList.remove('ce-color-variantes__item--active');
  });

  var selectedLabel = container.querySelector('label[for="' + input.id + '"]');
  if (selectedLabel) selectedLabel.classList.add('ce-color-variantes__item--active');

  var infoPiedras;
  try {
    infoPiedras = JSON.parse(container.getAttribute('data-info-piedras'));
  } catch (error) {
    console.error('Invalid data-info-piedras JSON in #' + container.id, error);
    return;
  }

  var datosVariante = infoPiedras.find(function(info) {
      return info.id == input.value;
  });

  if (datosVariante) {
    // Look everything up inside this card: the same product can appear twice on the page
    var contenedor = card.querySelector('#product-' + productId + '-' + infoIndex);
    if (!contenedor) return;

    var linkElements = card.querySelectorAll('a#link-' + productId + '-' + infoIndex);
    linkElements.forEach(function(element) {
      element.href = datosVariante.url;
    });

    var titleElement = contenedor.querySelector('#title-' + productId + '-' + infoIndex + ' a');
    if (titleElement) titleElement.textContent = datosVariante.title;

    var subtitleElement = contenedor.querySelector('p#subtitle-' + productId + '-' + infoIndex);
    if (subtitleElement) subtitleElement.innerHTML = datosVariante.feature;

    var contenedorPrice = contenedor.querySelector('.ProductItem__PriceList');

    // Prices arrive as strings in cents, so compare them as numbers ("100000" > "85000" is false as text)
    var precio = Number(datosVariante.price);
    var precioComparado = Number(datosVariante.compare_at_price);
    var enOferta = precioComparado > precio;

    var precioFormateado = formatearPrecio(precio);
    var precioElements = card.querySelectorAll('#price-' + productId + '-' + infoIndex);
    precioElements.forEach(function(element) {
      element.textContent = precioFormateado;
    });

    var comparePriceFormateado = formatearPrecio(precioComparado);
    var comparePriceElements = contenedor.querySelectorAll('#compare-at-price-' + productId + '-' + infoIndex);

    if (comparePriceElements.length === 0 && enOferta && contenedorPrice) {
      var comparePriceElement = document.createElement('span');
      comparePriceElement.id = 'compare-at-price-' + productId + '-' + infoIndex;
      comparePriceElement.className = 'ProductItem__Price Price Price--compareAt Text--subdued ce-pc__price';
      comparePriceElement.textContent = comparePriceFormateado;
      contenedorPrice.appendChild(comparePriceElement);
      comparePriceElements = [comparePriceElement];
    }

    // Actualizar todos los elementos en el array
    comparePriceElements.forEach(function(element) {
      if (enOferta) {
        element.textContent = comparePriceFormateado;
        element.style.display = '';
        precioElements.forEach(function(priceElement) {
          priceElement.style.color = 'var(--product-sale-price-color)';
        });
      } else {
        element.textContent = '';
        element.style.display = 'none';
        precioElements.forEach(function(priceElement) {
          priceElement.style.color = 'black';
        });
      }
    });

    actualizarSwiper(card.querySelector('#carousel-' + productId + '-' + infoIndex), productId, datosVariante);
  }
});


// Same output as Liquid's money_with_currency for this shop (EUR): 1,430.00 €
function formatearPrecio(centimos) {
  var partes = (centimos / 100).toFixed(2).split('.');
  partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return partes.join('.') + ' €';
}


function actualizarSwiper(carousel, productId, datosVariante) {
  // Without a carousel or images, keep the current slides instead of leaving the card empty
  if (!carousel || !datosVariante.media || !datosVariante.media.length) return;

  // Take the instance attached to this carousel: window.swipers is keyed by product, which may appear twice
  var swiperInstance = carousel.swiper;
  if (!swiperInstance) {
    swiperInstance = new Swiper(carousel, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    window.swipers[productId] = swiperInstance;
  }

  actualizarSwiperConNuevasImagenes(swiperInstance, datosVariante.media, function() {
    if (swiperInstance.slides.length >= 2) {
      swiperInstance.params.loop = true;
      swiperInstance.update();
    }
  });

}

function actualizarSwiperConNuevasImagenes(swiperInstance, nuevasImagenes, callback) {

  var carousel = swiperInstance.el;
  var loader = carousel.nextElementSibling;
  if (loader) loader.style.display = 'block';

  var navigationElements = swiperInstance.el.querySelectorAll('.swiper-button-next, .swiper-button-prev, .swiper-pagination');
  navigationElements.forEach(function(elem) { elem.style.display = 'none'; });

  swiperInstance.removeAllSlides();
  var imagesLoaded = 0;

  nuevasImagenes.forEach(function(imagen) {
    var img = new Image();
    // Count failed images too, otherwise one broken image leaves the loader spinning forever
    img.onload = img.onerror = function() {
      imagesLoaded++;
      if (imagesLoaded === nuevasImagenes.length) {
        if (loader) loader.style.display = 'none';
        navigationElements.forEach(function(elem) { elem.style.display = 'block'; });
        if (callback) callback();
      }
    };
    img.src = imagen.src;
    var slideContent = '<div class="swiper-slide"><img src="' + img.src + '" class="ProductItem__Image Image--lazyLoad"></div>';
    swiperInstance.appendSlide(slideContent);
  });

  swiperInstance.update();
}


document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.ProductItem.ce-product__item').forEach(function(elemento) {
    var mainProductId = elemento.getAttribute('data-product-id');
    var mainIndex = elemento.getAttribute('data-index');

    // Check the element itself, not window.swipers: that registry is keyed by product and a product can repeat
    var carousel = elemento.querySelector('#carousel-' + mainProductId + '-' + mainIndex);
    if (carousel && !carousel.swiper) {
      window.swipers[mainProductId] = new Swiper(carousel, {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

  });

});

